import React from 'react'
import HeaderImage from '../assets/executive.png'
import Navigation from '../navbar'
import George from '../assets/leadership/george.png'
import Footer from '../footer'
import { useNavigate } from 'react-router-dom';


function Leadership() {
    let navigate = useNavigate();

    const Management = () => {
        navigate("/robertasmah")
    }

    const ExecuManagement = () => {
        navigate("/leadership")
    }
    return (

        <>

            <Navigation />

            <div className="relative">
                <div className="absolute inset-0 bg-black bg-opacity-50 flex">
                    <h1 className="font-fjalla text-white text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:mt-24 lg:m-10 xl:text-6xl xl:mx-[270px]">

                    </h1>
                </div>
                <img
                    className="w-full h-auto xs:w-full xs:h-[200px] xs:object-cover sm:w-full sm:h-[300px] md:w-full md:h-[400px] md:object-cover lg:w-full lg:h-[500px] xl:w-full xl:"
                    src={HeaderImage}
                    alt="Ghana Gas GPP"
                />
            </div>

            <h1 className="font-fjalla text-gasblue text-2xl xs:mt-8 xs:ml-10 sm:text-3xl sm:mt-20 sm:ml-10 phone:hidden md:block  md:text-4xl md:mt-20 md:ml-10 lg:text-5xl lg:m-10 xl:text-5xl xl:mx-[270px] xl:mt-[100px] hover:cursor-pointer" onClick={ExecuManagement}>
                Executive Management
            </h1>

            <div class="grid md:grid-cols-3 phone:grid-cols-2 gap-4">
                <div class="col-span-1 flex items-start justify-end">
                    <img src={George} alt="CEO Image" className='scale-75' />
                </div>
                <div class="col-span-2 flex items-center">
                    <div>
                        <p class="text-black font-fjalla text-[24px] md:mx-20 phone:mx-10">Engr. George Wireko-Brobby </p>
                        <p class="text-black font-fira text-[20px] md:mx-20 phone:mx-10">Deputy Chief Executive Officer </p>
                        <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        Engr. George Wireko-Brobby is the Deputy Chief Executive Officer (DCEO) of the Ghana National Gas Limited Company (Ghana Gas). As the DCEO of Ghana Gas, he assists with Ghana Gas’ strategic planning and business development objectives among other core mandates to ensure operational excellence.                          
                        </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        Engr. George Wireko-Brobby is an accomplished Industrial Engineer who is driven by commitment to efficiency, innovation, and revenue growth across diverse industries. He has over 15 years extensive global experience in the construction, timber and logistic support services in the mining industry. </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        He has built a reputation for integrity, strategic vision, and the ability to deliver results. His career has been marked by a series of elevations, each reflecting his exceptional performance and dedication to work.</p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        He holds degrees in Industrial Engineering from Columbia University and Applied Physics with a minor in Mathematics from Morehouse College. His dual-degree education has equipped him with a unique blend of technical expertise and analytical skills, which he has successfully applied in various leadership roles throughout his career. As the DCEO of Ghana Gas, he is poised to contribute his extensive knowledge and leadership skills into the energy sector. </p>  <br />
                        <p class="text-black font-fira md:text-[19px] phone:text-[15px] md:mx-20 phone:mx-10 text-justify leading-snug">
                        He is enthusiastic about the achievements of the Sustainable Development Goals (SDGs) and equally passionate about the arts, music of various genres, current affairs, tennis and golf.                     
                        </p>  <br />
                    </div>
                </div>
            </div>
            <br />

            <Footer />
        </>
    )

}

export default Leadership;